import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			height: '42px',
			minHeight: '42px',
			display: 'flex',
			alignItems: 'center',
			gap: '6px',
			flexDirection: 'row',

			'&.Mui-selected': {
				fontWeight: 600,

				'& .MuiBadge-root': {
					background: theme.palette.primary.main,
					color: theme.palette.primary.contrastText,
				},
			},

			'& .MuiBadge-root': {
				width: '16px',
				height: '16px',
				background: theme.palette.info.main,
				color: theme.palette.info.contrastText,
				borderRadius: '50%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				fontSize: '10px',
				fontWeight: '400',
				lineHeight: '16px',

				[theme.breakpoints.down('xs')]: {
					display: 'none',
				},
			},

			fontSize: '11px',
			padding: '12px 6px',
		}),
	},
} as any;
